import { cn } from 'lib/utils';
import * as React from 'react';

/**
 * Text that is present for assistive technology but not painted — e.g. the
 * words behind a logo used as a heading. Tailwind's `sr-only` keeps the node
 * in the accessibility tree, which `display: none` would not.
 */
function VisuallyHidden({ className, ...props }: React.ComponentProps<'span'>) {
  return <span data-slot="visually-hidden" className={cn('sr-only', className)} {...props} />;
}

export { VisuallyHidden };
